import {useJobStore} from '@tinct/web-layout';
import {LOGO_REMATCH_JOB_TAG} from './use-logo-rematch';

/**
 * Whether a customer-logo re-match job is running (see useLogoRematch). While
 * it is, the variant pages are being rewritten underneath the studio, so the
 * hosts hold the user on the step rather than let them publish a selection
 * that is about to change.
 */
export const useIsRematchingLogos = () =>
  useJobStore((s) =>
    s.jobs.some((job) => job.tag === LOGO_REMATCH_JOB_TAG && job.status === 'running'),
  );

/** Tooltip copy shared by the hosts' disabled Continue / Review & publish buttons. */
export const REMATCHING_LOGOS_REASON =
  'Matching customer logos on your variant pages… please wait until it finishes.';
